import React, { useEffect, useMemo, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./HeroBanner.css";
import bannerImage from "../../images/bannerImage.png";

const AUTOPLAY_MS = 5000;
const RESUME_AUTOPLAY_MS = 10000;

const HeroBanner = ({ slidersMain = [] }) => {
  const slides = useMemo(() => {
    if (Array.isArray(slidersMain) && slidersMain.length > 0) {
      return slidersMain;
    }

    return [
      {
        id: "fallback-slide",
        slider_type: "Main",
        thubmnail: null,
        link: "",
      },
    ];
  }, [slidersMain]);

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const resumeTimeoutRef = useRef(null);

  useEffect(() => {
    setCurrentSlide(0);
  }, [slides.length]);

  useEffect(() => {
    if (!isAutoPlaying || slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, AUTOPLAY_MS);

    return () => clearInterval(interval);
  }, [isAutoPlaying, slides.length]);

  useEffect(() => {
    return () => {
      if (resumeTimeoutRef.current) {
        clearTimeout(resumeTimeoutRef.current);
      }
    };
  }, []);

  const pauseAutoPlay = () => {
    setIsAutoPlaying(false);

    if (resumeTimeoutRef.current) {
      clearTimeout(resumeTimeoutRef.current);
    }

    resumeTimeoutRef.current = setTimeout(() => {
      setIsAutoPlaying(true);
    }, RESUME_AUTOPLAY_MS);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    pauseAutoPlay();
  };

  const nextSlide = () => {
    if (slides.length <= 1) return;
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    pauseAutoPlay();
  };

  const prevSlide = () => {
    if (slides.length <= 1) return;
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    pauseAutoPlay();
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;

    if (diff > 50) {
      nextSlide();
    } else if (diff < -50) {
      prevSlide();
    }
  };

  const getImageUrl = (thumbnail) => {
    if (!thumbnail) return bannerImage;
    return `${process.env.REACT_APP_API_URL}/storage/${thumbnail}`;
  };

  return (
    <div className="hero-banner">
      <div
        className="banner-slider"
        style={{ transform: `translate3d(-${currentSlide * 100}%, 0, 0)` }}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {slides.map((slide, index) => (
          <div key={slide?.id || index} className="slide-content">
            <img
              src={getImageUrl(slide?.thubmnail)}
              alt={slide?.slider_type || "Banner"}
              className="character-image"
            />

            <div className="slide-angle-overlay" />
            <div className="slide-glow" />

            {slide?.link ? (
              <a
                href={slide.link}
                target="_blank"
                rel="noreferrer"
                className="slide-link-overlay"
                aria-label="Open banner link"
              />
            ) : null}
          </div>
        ))}
      </div>

      {slides.length > 1 && (
        <>
          <button
            type="button"
            className="nav-btn prev"
            onClick={prevSlide}
            aria-label="Previous slide"
          >
            <ChevronLeft size={24} strokeWidth={2.5} />
          </button>

          <button
            type="button"
            className="nav-btn next"
            onClick={nextSlide}
            aria-label="Next slide"
          >
            <ChevronRight size={24} strokeWidth={2.5} />
          </button>
        </>
      )}

      {/* {slides.length > 1 && (
        <div className="dot-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              type="button"
              className={`dot ${index === currentSlide ? "active" : ""}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default HeroBanner;